module.exports = __webpack_public_path__ + "img/confetti.3ed9f569.png";